<button name="deleteTaxYear"
        class="ws-flex-none ace-btn has-icon btn-primary btn-danger my-0"
        [disabled]="!canEnterEditMode || !canDeleteTaxYear"
        [title]="'Delete tax year ' + taxYear"
        type="button"
        (click)="deleteTaxYear()">
    <i class="fa fa-trash"></i>
</button>
